import { GroupTaskDetailController } from './group-task-detail.controller';

export const GroupTaskDetailComponent: ng.IComponentOptions = {
  bindings: {
    profile: '<',
  },
  templateUrl: 'tasks/components/group-task-detail/group-task-detail.html',
  controller: GroupTaskDetailController,
};
